import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import i18n from './i18n'
import { createPinia } from 'pinia'
import router from './router'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'


import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'



L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
})

createApp(App)
    .use(router)
    .use(createPinia())
    .use(i18n)
    .mount('#app')
